import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../assets/img/logo_t4a_white.svg";
import { FaUsers, FaInfoCircle, FaTrophy } from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import icon_hspu from "../assets/img/icon_hspu.svg";
import { FaCog, FaSignInAlt } from "react-icons/fa";
import "../css/Navigation.css";
import { useAuth } from './AuthContext';


function Navigation() {

  const navRef = useRef(null);
  const { isAuthenticated } = useAuth();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        expanded
      ) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const handleClose = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      ref={navRef}
      bg="dark"
      variant="dark"
      expand="lg"
      className="bartop"
      expanded={expanded}
    >
      <Container fluid>
        <div className="d-flex align-items-center justify-content-between w-100">
          <Navbar.Brand href="/" className="d-flex align-items-center">
            <img className="logo" src={logo} alt="Logo" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-nav" onClick={handleToggle} />
        </div>
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto nav-right">
            <NavLink className="nav-link" to="/" onClick={handleClose}>
              <div className="nav-icon">
                <AiFillHome />
              </div>
              Home
            </NavLink>
            <NavLink className="nav-link" to="/program" onClick={handleClose}>
              <div className="nav-icon">
                <img
                  className="nav-icon-custom-hspu"
                  src={icon_hspu}
                  alt="icon_hspu"
                />
              </div>
              Program
            </NavLink>
            {/*
            <NavLink className="nav-link" to="/train" onClick={handleClose}>
              <div className="nav-icon">
                <FaDumbbell />
              </div>
              Train
            </NavLink> */}
            <NavLink className="nav-link" to="/progress" onClick={handleClose}>
              <div className="nav-icon">
                <FaTrophy />
              </div>
              Progress
            </NavLink>
            <NavLink className="nav-link" to="/community" onClick={handleClose}>
              <div className="nav-icon">
                <FaUsers />
              </div>
              Community
            </NavLink>
            <NavLink className="nav-link" to="/about" onClick={handleClose}>
              <div className="nav-icon">
                <FaInfoCircle />
              </div>
              About
            </NavLink>
            {isAuthenticated ? (
              <NavLink className="nav-link" to="/settings" onClick={handleClose}>
                <div className="nav-icon">
                  <FaCog />
                </div>
                Settings
              </NavLink>
            ) : (
              <NavLink className="nav-link" to="/login" onClick={handleClose}>
                <div className="nav-icon">
                  <FaSignInAlt />
                </div>
                Login
              </NavLink>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
